export const DATE_FORMAT: string = 'DD/MM/YYYY';
export const DATE_FORMAT_MMM_D_YYYY: string = 'MMM D, YYYY';
export const DATE_FORMAT_MMMM_D_YYYY: string = 'MMMM D, YYYY';
export const DATE_FORMAT_MMMM_YYYY: string = 'MMMM YYYY';
export const DATE_FORMAT_MM_YYYY: string = 'MM YYYY';
export const DATE_FORMAT_MMM_YYYY: string = 'MMM YYYY';
export const DATE_FORMAT_MM_DOT_YYYY: string = 'MM.YYYY';
export const DATE_FORMAT_YYYY: string = 'YYYY';
export const DATE_FORMAT_MM_DOT_DD_DOT_YYYY: string = 'MM.DD.YYYY';

export function parseDate(input: string, format: string) {
  let parts: string[] = [];
  let formats: string[] = [];

  let day: string | undefined = undefined;
  let month: string | undefined = undefined;
  let year: string | undefined = undefined;

  let dayFormat: string | undefined = undefined;
  let monthFormat: string | undefined = undefined;
  let yearFormat: string | undefined = undefined;

  if (format === DATE_FORMAT) {
    parts = input.split('/');
    formats = format.split('/');
  } else if (
    format === DATE_FORMAT_MMMM_YYYY ||
    format === DATE_FORMAT_MMM_YYYY ||
    format === DATE_FORMAT_MM_YYYY ||
    format === DATE_FORMAT_MMM_D_YYYY
  ) {
    parts = input.split(' ');
    formats = format.split(' ');
  } else if (format === DATE_FORMAT_MM_DOT_YYYY || format === DATE_FORMAT_MM_DOT_DD_DOT_YYYY) {
    parts = input.split('.');
    formats = format.split('.');
  } else if (format === DATE_FORMAT_YYYY) {
    parts = [input];
    formats = [format];
  }

  if (format === DATE_FORMAT) {
    day = parts[0];
    month = parts[1];
    year = parts[2];

    dayFormat = formats[0];
    monthFormat = formats[1];
    yearFormat = formats[2];
  } else if (format === DATE_FORMAT_MMM_D_YYYY) {
    day = parts[1];
    month = parts[0];
    year = parts[2];

    dayFormat = formats[1];
    monthFormat = formats[0];
    yearFormat = formats[2];
  } else if (format === DATE_FORMAT_MMMM_YYYY || format === DATE_FORMAT_MMM_YYYY) {
    month = parts[0];
    year = parts[1];

    monthFormat = formats[0];
    yearFormat = formats[1];
  } else if (format === DATE_FORMAT_MM_YYYY) {
    month = parts[0];
    year = parts[1];

    monthFormat = formats[0];
    yearFormat = formats[1];
  } else if (format === DATE_FORMAT_MM_DOT_YYYY) {
    month = parts[0];
    year = parts[1];

    monthFormat = formats[0];
    yearFormat = formats[1];
  } else if (format === DATE_FORMAT_MM_DOT_DD_DOT_YYYY) {
    day = parts[1];
    month = parts[0];
    year = parts[2];

    dayFormat = formats[1];
    monthFormat = formats[0];
    yearFormat = formats[2];
  } else if (format === DATE_FORMAT_YYYY) {
    year = parts[0];
    yearFormat = formats[0];
  }

  return {
    date: [day, month, year] as [typeof day, typeof month, typeof year],
    formats: [dayFormat, monthFormat, yearFormat] as [typeof dayFormat, typeof monthFormat, typeof yearFormat],
  };
}
